// @flow
/**
 * Component that renders multiple-choise answer options.
 */
import React, { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { without } from "ramda";

import type { AnswerType } from "../../lib/types";
import { deepChange, sendModuleAnswer } from "../../actions";
import { setMessageAnswer } from "./actions";
import { getMessageAnswer, getMessagesHistory } from "../../store";
import { Answer } from "./Answer";
import { MessageContext } from "./BotMessageGenerator";

type Props = {
  answers: Array<AnswerType>,
};

export const MultiAnswers = (props: Props) => {
  const { answers } = props;

  const messageContext = useContext(MessageContext);

  const { messageNum, fromHistory, module } = messageContext;

  const dispatch = useDispatch();
  const messagesHistory = useSelector(getMessagesHistory);
  const messageAnswer = useSelector((state) => getMessageAnswer({ state, messageNum })) || [];

  /**
   * Handler for an answer click when user is able to select more than one answer at once before submitting.
   * @param answer
   */
  const onMultiAnswerClick = (answer) => {
    if (fromHistory) {
      return;
    }
    const { text: answerText } = answer;
    let newAnswers;
    if (!messageAnswer.includes(answerText)) {
      newAnswers = [...messageAnswer, answerText];
    } else {
      newAnswers = without([answerText], messageAnswer);
    }

    const answersWithIDs = answers.filter((a) => newAnswers.includes(a.text)).map((a) => ({ id: a.id, text: a.text }));

    dispatch(sendModuleAnswer(messagesHistory[messageNum].id, answersWithIDs));
    dispatch(setMessageAnswer({ messageNum, answer: newAnswers }));
    if (module.key) {
      dispatch(deepChange({ path: ["userData", module.key], value: newAnswers }));
    }
  };
  return answers.map<AnswerType>((answer, i) => {
    const className = messageAnswer.includes(answer.text) ? "active multi" : "multi";
    return (
      <Answer key={i} onClick={() => onMultiAnswerClick(answer)} className={className}>
        {answer.text}
      </Answer>
    );
  });
};
